<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="title2" id="_idParaDest-18"><a id="_idTextAnchor018"></a>A Storm in the Stars</p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">Don Zancanella</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-15"><img src="image/logo2.jpg"/></span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-15"><img src="image/delogo.jpg"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// A_Storm_in_the_Stars.FINALHC20.vue?7daf1920